import { action } from "satcheljs";

import type { WebpushClickedMessage } from "owa-serviceworker-webpush-v2/lib/types/webpush";

export interface ON_WEBPUSH_CLICKEDActionMessage {
    webpushType: string;
    itemId?: string; // Item ID to act on
    actionId?: string;
    upn: string;
}

export const onWebpushNotificationClickedAction: (webpushClickedMessage: WebpushClickedMessage) => ON_WEBPUSH_CLICKEDActionMessage = action("ON_WEBPUSH_CLICKED", webpushClickedMessage => {
    return webpushClickedMessage;
});
